import {LocationHistory} from "../../model/location-history";
import {LocationBreadcrumb} from "../../model/location/location-breadcrumb";
import {removeUndefined} from "../../util/util";
import {otsBaseApi} from "../ots-api";


const taggedBaseApi = otsBaseApi.enhanceEndpoints({addTagTypes: ["LocationHistory"]});

export const locationHistoryApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTicketLocationHistory: builder.query<LocationHistory, {
      id: string,
      database: string | undefined
    }>({
      query: ({id, database}) => ({
        url: database ? `/location/history/ticket/${id}?serviceLookup=${database}` : `/location/history/ticket/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, {id}) => [{type: "LocationHistory", id}],
    }),
    getShiftLocationHistory: builder.query<LocationHistory, {
      id: string,
      database: string | undefined
    }>({
      query: ({id, database}) => ({
        url: database ? `/location/history/shift/${id}?serviceLookup=${database}` : `/location/history/shift/${id}`,
        method: "GET"
      }),
      providesTags: (result, error, {id}) => [{type: "LocationHistory", id}],
    }),
    /**
     * The driver's GPS breadcrumbs over a ticket's travel window (`GET /tickets/{id}/gps-breadcrumbs`): the
     * purpose-built endpoint, lighter than the ticket's full location history.
     */
    getTicketGpsBreadcrumbs: builder.query<LocationBreadcrumb[], { id: string, tenantCode?: string }>({
      query: ({id, tenantCode}) => ({
        url: `/tickets/${encodeURIComponent(id)}/gps-breadcrumbs`,
        method: "GET",
        params: removeUndefined({tenantCode}),
      }),
      transformResponse: (response: { breadcrumbs?: LocationBreadcrumb[] }) => response?.breadcrumbs ?? [],
      providesTags: (result, error, {id}) => [{type: "LocationHistory", id: `breadcrumbs_${id}`}],
    }),
  })
});

export const {
  useGetTicketLocationHistoryQuery,
  useGetShiftLocationHistoryQuery,
  useGetTicketGpsBreadcrumbsQuery,
} = locationHistoryApi;
